'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = undefined;

var _Footer2 = require('./Footer');

var _Footer3 = _interopRequireDefault(_Footer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Footer = _Footer3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/index.js
// module id = 1661
// module chunks = 0